import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Badge, Pagination } from "antd";
import CustomTabs from "components/tabs/customTab";
import LeaveRequestCard from "./LeaveRequestCard";
import { 
	getLeaveList, 
} from "../../../../../redux/leave/leaveState";
import { 
  CircleAlert,
  CircleCheck,
  CircleX
} from "lucide-react";

const TabLabel = ({ text, count }) => (
  <div className="flex items-center justify-center gap-2">
    <span className="text-sm font-medium">{text}</span>
    <Badge
      count={count}
      style={{
        backgroundColor: text === "Pending" ? "#ff0000" : "#fff",
        color: text === "Pending" ? "#fff" : "#000",
        border: "1px solid #d9d9d9",
      }}
    />
  </div>
);

const LeaveRequestTab = ({ 
  recordList, 
  recordStat,
  doSearch,
  pagination,
  filters
}) => {
  const [activeTab, setActiveTab] = useState("Pending");
  const [statusId, setStatusId] = useState(70);

  const tabOptions = [
    { label: <TabLabel text="Pending" count={recordStat?.pending} />, value: "Pending" },
    { label: <TabLabel text="Approved" count={recordStat?.approved} />, value: "Approved" },
    { label: <TabLabel text="Rejected" count={recordStat?.rejected} />, value: "Rejected" },
  ];

  const onTabChange = (value) => {
    setActiveTab(value);
    if (value === "Approved") setStatusId(71);
    else if (value === "Rejected") setStatusId(72);
    else setStatusId(70);
  };

  const EmptyStateIcon = ({ tab }) => {
    const iconProps = { className: "w-12 h-12 text-slate-700 mx-auto mb-4" };
    
    switch (tab) {
      case "Approved":
        return <CircleCheck {...iconProps} />;
      case "Rejected":
        return <CircleX {...iconProps} />;
      default: 
        return <CircleAlert {...iconProps} />;
    }
  };

  useEffect(() => {
    doSearch({
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10, 
      status_id: statusId,
    });
  }, [doSearch, statusId]);

  return (
    <div className="flex flex-col gap-2">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={onTabChange}
      />

      <div className="flex-1 outline-none mt-6">
        <div className="h-[600px] overflow-y-auto">
          <div className="space-y-4 pr-4">
            {recordList && recordList.length > 0 ? (
              recordList.map((leave) => <LeaveRequestCard key={leave.id} {...leave} />)
            ) : (
              <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border">
                <div className="px-6 pb-6 py-12 text-center">
                  <EmptyStateIcon tab={activeTab} />
                  <p className="text-slate-700 font-medium">
                    No {activeTab.toLowerCase()} requests found
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination.current_page}
              pageSize={pagination.per_page}
              total={pagination.total}
              showSizeChanger={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => ({
  recordList: state.leave.leaveList?.items,
  pagination: state.leave.leaveList?.pagination,
  recordData: state.leave.leaveList,
  recordStat: state.leave.leaveStat.data,
  filters: state.leave.leaveList.filters,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getLeaveList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveRequestTab);
